// extracted by mini-css-extract-plugin
export default {"Action":"ActionComponent_Action__m9DYX"};